// extracted by mini-css-extract-plugin
module.exports = {"content":"Profile_content__19kFw","avatar":"Profile_avatar__3XIdW","description":"Profile_description__2cmEM","heading":"Profile_heading__Nq0CS"};